import Breadcrumbs from '../../layout/breadcrumbs';
import { Link, useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div id="page-content">
      <Breadcrumbs crumbs={[{ page: '404' }]}/>

      <div className="container">
        <section id="404">
          <div className="error-page">
            <div className="title">
              <img alt="404 Error" src="/assets/img/error-page-background.png"
                   className="top"/>
              <header>404</header>
              <img alt="404 Error" src="/assets/img/error-page-background.png"
                   className="bottom"/>
            </div>
            <h2 className="no-border">Page not found</h2>
            <Link to="#" className="link-arrow back"
                  onClick={() => navigate(-2)}>Go Back</Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default NotFound;